export { default as withRedux } from "./withRedux";



// WEBPACK FOOTER //
// ./src/hoc/index.js